export class ContactDetails {
    emailAddress: string | null
    addressLine1: string | null
    addressLine2: string | null
    city: string | null
    phoneNumber: string | null
}